import React, { Component } from "react";
import * as Constants from "../../common/Global/constants";
import { TableIcon, AddNewButtonLayout } from "../../common/Global/globalStyles.style";
import { getLocalStorageVariables, isEmptyVariable, isEmptyArray, truncateString,
	getOnlyFileNameFromPath, 
	handleTokenExpiry} from "../../common/Global/commonFunctions";
import { Modal } from "react-bootstrap";
import AlertDialog from '../../common/AlertDialog';
import UploadAttachment from './uploadAttachment';

let userDetails = getLocalStorageVariables();

class AttachmentList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showUploadAttachmentDialog: false,
			showBtnLoader:false,
            showAlertDialogInfo:false,
            alertDialogMessageInfo:"",
		};
		userDetails = getLocalStorageVariables();
	}

    componentDidMount() {}
    
	componentDidUpdate(prevProps) {
        if (JSON.stringify(prevProps) !== JSON.stringify(this.props) && this.props.showAttachmentDialog) {
            this.getInitData();
		}
	}
    
    // show attachment list dialog
    showUploadAttchmentDialog = () => {
        this.setState({
            showUploadAttachmentDialog:true
        })
    }

	// Closes the upload attachment dialog and optionally reloads data.
    uploadAttachmentDialogClose = (reloadFlag) => {
        this.setState({
            showUploadAttachmentDialog:false
        }, () => {
			if(reloadFlag == true){
				this.getInitData();
			}
		})
    }

	// handle delete attchment
	handleDeleteItemClick = (item) => {
		this.setState({
			alertDialogHeading:"Delete Attachment",
			proceedBtnLabel:"Delete",
			selectedAttachmentId:item.attachmentId,
			showAlertDialog:true,
			alertDialogMessage:"Are you sure you want to delete "+getOnlyFileNameFromPath(item.filePath)+"?"
		})
	}

	// handle close event for alert dialog
	handleAlertDialogClose = () => {
		this.setState({
			alertDialogHeading:"",
			proceedBtnLabel:"",
			showAlertDialog:false,
			alertDialogMessage:""
		})
	}

	// handle attachment dialog close event
    handleAttachmentDialogClose = () => {
        this.props.handleAttachmentDialogClose();
    }

	// Handle info alert dialog close event
    handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        });
    }

	// download attachment
	downloadAttachment = (filePath,e) => {
        e.stopPropagation();
        fetch(Constants.API_SERVER_PATH+filePath)
        .then(response => {
			return response.blob();
		})
        .then(blob => {
			let fileName = getOnlyFileNameFromPath(filePath);
			const link = document.createElement('a');
			link.href = URL.createObjectURL(blob);
			link.setAttribute('download', fileName);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		});
    }

	/*******************API CALLS*******************/
	getInitData = () => {
		fetch(Constants.GetFrameworkAttachment,
		{
			method: "POST",
			mode:'cors',
			body: new URLSearchParams({
				email:userDetails.email,
				accessToken:userDetails.accessToken,
				frameworkClauseId:this.props.frameworkClauseId
			})
		})
		.then(response => { return response.json(); } )
		.then(data =>
		{
			if(handleTokenExpiry(data.responseCode)) return;
			else if(data.responseCode === Constants.CODE_SUCCESS){
				let tempAttachments = data.data.attachments;

				this.setState({
					showLoader:false,
					attachment:tempAttachments
				});
			}else{
				this.setState({
					showLoader:false,
					showAlertDialogInfo:true,
					alertDialogMessageInfo:data.responseMessage
				});
			}
		});
	};

	handleRecordOperation = () => {
		this.setState({
			showBtnLoader:true
		})

        fetch(Constants.DeleteFrameworkAttachment, {
            method: "POST",
            mode: "cors",
            body: new URLSearchParams({
				email: userDetails.email,
            	accessToken: userDetails.accessToken,
				attachmentId: this.state.selectedAttachmentId
			})
        })
        .then((response) => {
            return response.json();
        })
        .then((data) => {
			if(handleTokenExpiry(data.responseCode)) return;
            else if (data.responseCode === Constants.CODE_SUCCESS) {
                this.setState({
                    alertDialogHeading:"",
                    proceedBtnLabel:"",
					selectedAttachmentId:"",
                    showAlertDialog:false,
                    alertDialogMessage:"",
					showBtnLoader:false
                },()=>{
                    this.getInitData();
                })
            } else {
				this.setState({
					showBtnLoader:false,
					showAlertDialogInfo:true,
					alertDialogMessageInfo:data.responseMessage
				})
            }
        });

	}
	/*******************API CALLS END HERE*******************/

    render() {
		return (
			<section>
				<Modal
					className="task-select-dept-dialog custom-dialog"
					show={this.props.showAttachmentDialog}
					onHide={this.handleAttachmentDialogClose}
					backdrop="static"
				>
					<Modal.Header>
						<h5>{"Attachment"}</h5>
						<button onClick={this.handleAttachmentDialogClose} type="button" data-dismiss="modal">
							<span class="material-icons">close</span>
						</button>
					</Modal.Header>
					<hr />
					<div className="modal-body">
						<div className="body-wrapper">
							{this.props.isFrameworkEdit &&
								<div className="search-addnew-bg m-t-0">
									<div className="search-addnew" style={{alignItems:"center"}}>
										<div />
										<div className="search-filter-layout" style={{position:"relative"}}>
											<AddNewButtonLayout themeSettings={this.props.themeSettings}>
												<a href="javascript:void(0);" onClick={this.showUploadAttchmentDialog}>
													<span className="material-icons">add_circle</span>
													<p>{"Add Attachment"}</p>
												</a>
											</AddNewButtonLayout>
										</div>
									</div>
								</div>
							}

							<div style={{position:"relative"}}>
								{
									!isEmptyArray(this.state.attachment) && 
									<div className="common-tab-bg">
										<div className="common-table" style={{width:"100%"}}>
											<table className="table">
												<thead>
													<tr>
														<th className="text-center" width={"5%"}>No.</th>
														<th width={"5%"}>File Name</th>
														<th width={"5%"}>Description</th>
														<th className="text-center" width={"5%"}>Download</th>
														{this.props.isFrameworkEdit &&
															<th className="text-center"  width={"5%"}></th>
														}
													</tr>
												</thead>
												<tbody>
												{
													!isEmptyArray(this.state.attachment) && 
													this.state.attachment.map((item,idx) => {
														return !item.isDeleted?<tr>
															<td className="text-center">{(idx+1)}</td>
															<td>{getOnlyFileNameFromPath(item.filePath)}</td>
															<td>{truncateString(item.descriptions,Constants.REMARKS_STRING_LENGTH)}</td>
															<TableIcon themeSettings={this.props.themeSettings} className="text-center">
																<span class="material-icons" onClick={this.downloadAttachment.bind(this, item.filePath)}>get_app</span>
															</TableIcon>
															{this.props.isFrameworkEdit &&
																<TableIcon themeSettings={this.props.themeSettings} className="text-center">
																	<span className="material-icons"
																		onClick={this.handleDeleteItemClick.bind(this,item,idx)}>delete</span>
																</TableIcon>
															}
														</tr>
														:
														null
													})
												}
												</tbody>
											</table>
										</div>
									</div>
								}
								{
									isEmptyArray(this.state.attachment) &&
									<div class="no-items-layout">
										<div class="no-items-card">
											<h6>
											{
												Constants.NO_RECORDS_WARNING
											}
											</h6>
										</div>
									</div>
								}
							</div>
						</div>
					</div>
				</Modal>

				<UploadAttachment
					showUploadAttachmentDialog={this.state.showUploadAttachmentDialog}
					uploadAttachmentDialogClose={this.uploadAttachmentDialogClose}
					themeSettings={this.props.themeSettings}
					frameworkId={this.props.rootFrameworkId}
					frameworkClauseId={this.props.frameworkClauseId}
				/>

				<AlertDialog
                    showAlertDialog={this.state.showAlertDialog}
                    handleAlertDialogClose={this.handleAlertDialogClose}
                    type={Constants.ALERT_TYPE_WARNING}
                    alertDialogHeading={this.state.alertDialogHeading}
                    alertDialogMessage={this.state.alertDialogMessage}
                    proceedBtnClick={this.handleRecordOperation}
                    proceedBtnLabel={this.state.proceedBtnLabel}
					showLoader={this.state.showBtnLoader}
                    themeSettings={this.props.themeSettings}
                />
				<AlertDialog
					showAlertDialog={this.state.showAlertDialogInfo}
					handleAlertDialogClose={this.handleAlertDialogCloseInfo}
					type={Constants.ALERT_TYPE_ALERT}
					alertDialogMessage={this.state.alertDialogMessageInfo}
					proceedBtnClick={this.handleAlertDialogCloseInfo}
					proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
					themeSettings={this.props.themeSettings}
				/>
			</section>
		);
	}
}

export default AttachmentList;
